import React from 'react';

import { Advnture } from '../../modules/sites/definitions/Advnture';
import { AndroidCentral } from '../../modules/sites/definitions/AndroidCentral';
import { AVNetwork } from '../../modules/sites/definitions/AVNetwork';
import { BikePerfect } from '../../modules/sites/definitions/BikePerfect';
import { Cinemablend } from '../../modules/sites/definitions/Cinemablend';
import { CoachMag } from '../../modules/sites/definitions/CoachMag';
import { CountryLife } from '../../modules/sites/definitions/CountryLife';
import { CreativeBloq } from '../../modules/sites/definitions/CreativeBloq';
import { Cyclingnews } from '../../modules/sites/definitions/Cyclingnews';
import { CyclingWeekly } from '../../modules/sites/definitions/CyclingWeekly';
import { Decanter } from '../../modules/sites/definitions/Decanter';
import { DigitalCameraWorld } from '../../modules/sites/definitions/DigitalCameraWorld';
import { FitAndWell } from '../../modules/sites/definitions/FitAndWell';
import { FourFourTwo } from '../../modules/sites/definitions/FourFourTwo';
import { GamesRadar } from '../../modules/sites/definitions/GamesRadar';
import { Gardeningetc } from '../../modules/sites/definitions/Gardeningetc';
import { GardeningKnowHow } from '../../modules/sites/definitions/GardeningKnowHow';
import { GetPriceAU } from '../../modules/sites/definitions/GetPriceAU';
import { GolfMonthly } from '../../modules/sites/definitions/GolfMonthly';
import { GoodToKnow } from '../../modules/sites/definitions/GoodToKnow';
import { GuitarPlayer } from '../../modules/sites/definitions/GuitarPlayer';
import { GuitarWorld } from '../../modules/sites/definitions/GuitarWorld';
import { HomeBuilding } from '../../modules/sites/definitions/HomeBuilding';
import { HomesAndGardens } from '../../modules/sites/definitions/HomesAndGardens';
import { HorseAndHound } from '../../modules/sites/definitions/HorseAndHound';
import { IdealHome } from '../../modules/sites/definitions/IdealHome';
import { IMore } from '../../modules/sites/definitions/IMore';
import { ITPro } from '../../modules/sites/definitions/ITPro';
import { Kiplinger } from '../../modules/sites/definitions/Kiplinger';
import { LaptopMag } from '../../modules/sites/definitions/LaptopMag';
import { Livingetc } from '../../modules/sites/definitions/Livingetc';
import { LouderSound } from '../../modules/sites/definitions/LouderSound';
import { MarieClaireUK } from '../../modules/sites/definitions/MarieClaireUK';
import { MarieClaireUS } from '../../modules/sites/definitions/MarieClaireUS';
import { MoneyWeek } from '../../modules/sites/definitions/MoneyWeek';
import { MotorBoatAndYachting } from '../../modules/sites/definitions/MotorBoatAndYachting';
import { MountainBikeRider } from '../../modules/sites/definitions/MountainBikeRider';
import { MusicRadar } from '../../modules/sites/definitions/MusicRadar';
import { MusicWeek } from '../../modules/sites/definitions/MusicWeek';
import { MyImperfectLife } from '../../modules/sites/definitions/MyImperfectLife';
import { MyVoucherCodes } from '../../modules/sites/definitions/MyVoucherCodes';
import { PCGamer } from '../../modules/sites/definitions/PCGamer';
import { PetsRadar } from '../../modules/sites/definitions/PetsRadar';
import { PracticalBoatOwner } from '../../modules/sites/definitions/PracticalBoatOwner';
import { PracticalCaravan } from '../../modules/sites/definitions/PracticalCaravan';
import { PracticalMotorhome } from '../../modules/sites/definitions/PracticalMotorhome';
import { RealHomes } from '../../modules/sites/definitions/RealHomes';
import { RugbyWorld } from '../../modules/sites/definitions/RugbyWorld';
import { SheerLuxe } from '../../modules/sites/definitions/SheerLuxe';
import { Shortlist } from '../../modules/sites/definitions/Shortlist';
import { Space } from '../../modules/sites/definitions/Space';
import { T3 } from '../../modules/sites/definitions/T3';
import { TechLearning } from '../../modules/sites/definitions/TechLearning';
import { TechRadar } from '../../modules/sites/definitions/TechRadar';
import { TechRadarPro } from '../../modules/sites/definitions/TechRadarPro';
import { TheBlend } from '../../modules/sites/definitions/TheBlend';
import { TheWeek } from '../../modules/sites/definitions/TheWeek';
import { TomsGuide } from '../../modules/sites/definitions/TomsGuide';
import { TomsHardware } from '../../modules/sites/definitions/TomsHardware';
import { Wallpaper } from '../../modules/sites/definitions/Wallpaper';
import { WhatHiFi } from '../../modules/sites/definitions/WhatHiFi';
import { WhatToWatch } from '../../modules/sites/definitions/WhatToWatch';
import { WhoWhatWear } from '../../modules/sites/definitions/WhoWhatWear';
import { WindowsCentral } from '../../modules/sites/definitions/WindowsCentral';
import { WomanAndHome } from '../../modules/sites/definitions/WomanAndHome';
import { YachtingAndBoatingWorld } from '../../modules/sites/definitions/YachtingAndBoatingWorld';
import { YachtingMonthly } from '../../modules/sites/definitions/YachtingMonthly';
import { YachtingWorld } from '../../modules/sites/definitions/YachtingWorld';
import { Site } from '../../modules/sites/Site';

import { AdvntureSiteWrapper } from './AdvntureSiteWrapper/loadable';
import { AndroidcentralSiteWrapper } from './AndroidcentralSiteWrapper/loadable';
import { AvnetworkSiteWrapper } from './AvnetworkSiteWrapper/loadable';
import { BikeperfectSiteWrapper } from './BikeperfectSiteWrapper/loadable';
import { CinemablendSiteWrapper } from './CinemablendSiteWrapper/loadable';
import { CoachmagSiteWrapper } from './CoachmagSiteWrapper/loadable';
import { CountrylifeSiteWrapper } from './CountrylifeSiteWrapper/loadable';
import { CreativebloqSiteWrapper } from './CreativebloqSiteWrapper/loadable';
import { CyclingnewsSiteWrapper } from './CyclingnewsSiteWrapper/loadable';
import { CyclingweeklySiteWrapper } from './CyclingweeklySiteWrapper/loadable';
import { DecanterSiteWrapper } from './DecanterSiteWrapper/loadable';
import { DefaultSiteWrapper } from './DefaultSiteWrapper/loadable';
import { DigitalcameraworldSiteWrapper } from './DigitalcameraworldSiteWrapper/loadable';
import { FitandwellSiteWrapper } from './FitandwellSiteWrapper/loadable';
import { FourfourtwoSiteWrapper } from './FourfourtwoSiteWrapper/loadable';
import { GamesradarSiteWrapper } from './GamesradarSiteWrapper/loadable';
import { GardeningetcSiteWrapper } from './GardeningetcSiteWrapper/loadable';
import { GardeningKnowHowSiteWrapper } from './GardeningKnowHowSiteWrapper/loadable';
import { GetpriceSiteWrapper } from './GetpriceSiteWrapper/loadable';
import { GolfmonthlySiteWrapper } from './GolfmonthlySiteWrapper/loadable';
import { GoodtoSiteWrapper } from './GoodtoSiteWrapper/loadable';
import { GuitarplayerSiteWrapper } from './GuitarplayerSiteWrapper/loadable';
import { GuitarworldSiteWrapper } from './GuitarworldSiteWrapper/loadable';
import { HomebuildingSiteWrapper } from './HomebuildingSiteWrapper/loadable';
import { HomesandgardensSiteWrapper } from './HomesandgardensSiteWrapper/loadable';
import { HorseandhoundSiteWrapper } from './HorseandhoundSiteWrapper/loadable';
import { IdealhomeSiteWrapper } from './IdealhomeSiteWrapper/loadable';
import { ImoreSiteWrapper } from './ImoreSiteWrapper/loadable';
import { ItproSiteWrapper } from './ItproSiteWrapper/loadable';
import { KiplingerSiteWrapper } from './KiplingerSiteWrapper/loadable';
import { LaptopmagSiteWrapper } from './LaptopmagSiteWrapper/loadable';
import { LivingetcSiteWrapper } from './LlivingetcSiteWrapper/loadable';
import { LoudersoundSiteWrapper } from './LoudersoundSiteWrapper/loadable';
import { MarieclaireukSiteWrapper } from './MarieclaireukSiteWrapper/loadable';
import { MarieclaireusSiteWrapper } from './MarieclaireusSiteWrapper/loadable';
import { MbrSiteWrapper } from './MbrSiteWrapper/loadable';
import { MbySiteWrapper } from './MbySiteWrapper/loadable';
import { MoneyweekSiteWrapper } from './MoneyweekSiteWrapper/loadable';
import { MusicradarSiteWrapper } from './MusicradarSiteWrapper/loadable';
import { MusicweekSiteWrapper } from './MusicweekSiteWrapper/loadable';
import { MyimperfectlifeSiteWrapper } from './MyimperfectlifeSiteWrapper/loadable';
import { MyvouchercodesSiteWrapper } from './MyvouchercodesSiteWrapper/loadable';
import { PboSiteWrapper } from './PboSiteWrapper/loadable';
import { PcgamerSiteWrapper } from './PcgamerSiteWrapper/loadable';
import { PetsradarSiteWrapper } from './PetsradarSiteWrapper/loadable';
import { PracticalcaravanSiteWrapper } from './PracticalcaravanSiteWrapper/loadable';
import { PracticalmotorhomeSiteWrapper } from './PracticalmotorhomeSiteWrapper/loadable';
import { RealhomesSiteWrapper } from './RealhomesSiteWrapper/loadable';
import { RugbyworldSiteWrapper } from './RugbyworldSiteWrapper/loadable';
import { SheerLuxeSiteWrapper } from './SheerLuxeSiteWrapper/loadable';
import { ShortlistSiteWrapper } from './ShortlistSiteWrapper/loadable';
import { SpaceSiteWrapper } from './SpaceSiteWrapper/loadable';
import { T3SiteWrapper } from './T3SiteWrapper/loadable';
import { TechlearningSiteWrapper } from './TechlearningSiteWrapper/loadable';
import { TechradarSiteWrapper } from './TechradarSiteWrapper/loadable';
import { TheBlendSiteWrapper } from './TheBlendSiteWrapper/loadable';
import { TheweekSiteWrapper } from './TheweekSiteWrapper/loadable';
import { TomsguideSiteWrapper } from './TomsguideSiteWrapper/loadable';
import { TomshardwareSiteWrapper } from './TomshardwareSiteWrapper/loadable';
import { WallpaperSiteWrapper } from './WallpaperSiteWrapper/loadable';
import { WhathifiSiteWrapper } from './WhathifiSiteWrapper/loadable';
import { WhattowatchSiteWrapper } from './WhattowatchSiteWrapper/loadable';
import { WhowhatwearSiteWrapper } from './WhowhatwearSiteWrapper/loadable';
import { WindowscentralSiteWrapper } from './WindowscentralSiteWrapper/loadable';
import { WomanandhomeSiteWrapper } from './WomanandhomeSiteWrapper/loadable';
import { YachtingmonthlySiteWrapper } from './YachtingmonthlySiteWrapper/loadable';
import { YachtingworldSiteWrapper } from './YachtingworldSiteWrapper/loadable';
import { YbwSiteWrapper } from './YbwSiteWrapper/loadable';

export const SiteWrapper: React.FC<{ children: React.ReactNode; site: Site }> = ({
  site,
  children,
}) => {
  switch (site) {
    case CountryLife: {
      return <CountrylifeSiteWrapper>{children}</CountrylifeSiteWrapper>;
    }
    case Decanter: {
      return <DecanterSiteWrapper>{children}</DecanterSiteWrapper>;
    }
    case HorseAndHound: {
      return <HorseandhoundSiteWrapper>{children}</HorseandhoundSiteWrapper>;
    }
    case MountainBikeRider: {
      return <MbrSiteWrapper>{children}</MbrSiteWrapper>;
    }
    case MotorBoatAndYachting: {
      return <MbySiteWrapper>{children}</MbySiteWrapper>;
    }
    case PracticalBoatOwner: {
      return <PboSiteWrapper>{children}</PboSiteWrapper>;
    }
    case RugbyWorld: {
      return <RugbyworldSiteWrapper>{children}</RugbyworldSiteWrapper>;
    }
    case YachtingMonthly: {
      return <YachtingmonthlySiteWrapper>{children}</YachtingmonthlySiteWrapper>;
    }
    case YachtingWorld: {
      return <YachtingworldSiteWrapper>{children}</YachtingworldSiteWrapper>;
    }
    case YachtingAndBoatingWorld: {
      return <YbwSiteWrapper>{children}</YbwSiteWrapper>;
    }
    case Shortlist: {
      return <ShortlistSiteWrapper>{children}</ShortlistSiteWrapper>;
    }
    case Advnture: {
      return <AdvntureSiteWrapper>{children}</AdvntureSiteWrapper>;
    }
    case AndroidCentral: {
      return <AndroidcentralSiteWrapper>{children}</AndroidcentralSiteWrapper>;
    }
    case AVNetwork: {
      return <AvnetworkSiteWrapper>{children}</AvnetworkSiteWrapper>;
    }
    case BikePerfect: {
      return <BikeperfectSiteWrapper>{children}</BikeperfectSiteWrapper>;
    }
    case Cinemablend: {
      return <CinemablendSiteWrapper>{children}</CinemablendSiteWrapper>;
    }
    case CreativeBloq: {
      return <CreativebloqSiteWrapper>{children}</CreativebloqSiteWrapper>;
    }
    case Cyclingnews: {
      return <CyclingnewsSiteWrapper>{children}</CyclingnewsSiteWrapper>;
    }
    case CoachMag: {
      return <CoachmagSiteWrapper>{children}</CoachmagSiteWrapper>;
    }
    case FourFourTwo: {
      return <FourfourtwoSiteWrapper>{children}</FourfourtwoSiteWrapper>;
    }
    case DigitalCameraWorld: {
      return <DigitalcameraworldSiteWrapper>{children}</DigitalcameraworldSiteWrapper>;
    }
    case GardeningKnowHow: {
      return <GardeningKnowHowSiteWrapper>{children}</GardeningKnowHowSiteWrapper>;
    }
    case GetPriceAU: {
      return <GetpriceSiteWrapper>{children}</GetpriceSiteWrapper>;
    }
    case GamesRadar: {
      return <GamesradarSiteWrapper>{children}</GamesradarSiteWrapper>;
    }
    case GuitarPlayer: {
      return <GuitarplayerSiteWrapper>{children}</GuitarplayerSiteWrapper>;
    }
    case GuitarWorld: {
      return <GuitarworldSiteWrapper>{children}</GuitarworldSiteWrapper>;
    }
    case IMore: {
      return <ImoreSiteWrapper>{children}</ImoreSiteWrapper>;
    }
    case ITPro: {
      return <ItproSiteWrapper>{children}</ItproSiteWrapper>;
    }
    case LaptopMag: {
      return <LaptopmagSiteWrapper>{children}</LaptopmagSiteWrapper>;
    }
    case LouderSound: {
      return <LoudersoundSiteWrapper>{children}</LoudersoundSiteWrapper>;
    }
    case MusicRadar: {
      return <MusicradarSiteWrapper>{children}</MusicradarSiteWrapper>;
    }
    case MusicWeek: {
      return <MusicweekSiteWrapper>{children}</MusicweekSiteWrapper>;
    }
    case PCGamer: {
      return <PcgamerSiteWrapper>{children}</PcgamerSiteWrapper>;
    }
    case PetsRadar: {
      return <PetsradarSiteWrapper>{children}</PetsradarSiteWrapper>;
    }
    case Space: {
      return <SpaceSiteWrapper>{children}</SpaceSiteWrapper>;
    }
    case TechLearning: {
      return <TechlearningSiteWrapper>{children}</TechlearningSiteWrapper>;
    }
    case TomsGuide: {
      return <TomsguideSiteWrapper>{children}</TomsguideSiteWrapper>;
    }
    case TomsHardware: {
      return <TomshardwareSiteWrapper>{children}</TomshardwareSiteWrapper>;
    }
    case TechRadar:
    case TechRadarPro: {
      return <TechradarSiteWrapper>{children}</TechradarSiteWrapper>;
    }
    case WhatHiFi: {
      return <WhathifiSiteWrapper>{children}</WhathifiSiteWrapper>;
    }
    case WhatToWatch: {
      return <WhattowatchSiteWrapper>{children}</WhattowatchSiteWrapper>;
    }
    case WindowsCentral: {
      return <WindowscentralSiteWrapper>{children}</WindowscentralSiteWrapper>;
    }
    case CyclingWeekly: {
      return <CyclingweeklySiteWrapper>{children}</CyclingweeklySiteWrapper>;
    }
    case FitAndWell: {
      return <FitandwellSiteWrapper>{children}</FitandwellSiteWrapper>;
    }
    case Gardeningetc: {
      return <GardeningetcSiteWrapper>{children}</GardeningetcSiteWrapper>;
    }
    case GolfMonthly: {
      return <GolfmonthlySiteWrapper>{children}</GolfmonthlySiteWrapper>;
    }
    case GoodToKnow: {
      return <GoodtoSiteWrapper>{children}</GoodtoSiteWrapper>;
    }
    case HomesAndGardens: {
      return <HomesandgardensSiteWrapper>{children}</HomesandgardensSiteWrapper>;
    }
    case HomeBuilding: {
      return <HomebuildingSiteWrapper>{children}</HomebuildingSiteWrapper>;
    }
    case IdealHome: {
      return <IdealhomeSiteWrapper>{children}</IdealhomeSiteWrapper>;
    }
    case Kiplinger: {
      return <KiplingerSiteWrapper>{children}</KiplingerSiteWrapper>;
    }
    case Livingetc: {
      return <LivingetcSiteWrapper>{children}</LivingetcSiteWrapper>;
    }
    case MarieClaireUK: {
      return <MarieclaireukSiteWrapper>{children}</MarieclaireukSiteWrapper>;
    }
    case MarieClaireUS: {
      return <MarieclaireusSiteWrapper>{children}</MarieclaireusSiteWrapper>;
    }
    case MyImperfectLife: {
      return <MyimperfectlifeSiteWrapper>{children}</MyimperfectlifeSiteWrapper>;
    }
    case MyVoucherCodes: {
      return <MyvouchercodesSiteWrapper>{children}</MyvouchercodesSiteWrapper>;
    }
    case RealHomes: {
      return <RealhomesSiteWrapper>{children}</RealhomesSiteWrapper>;
    }
    case T3: {
      return <T3SiteWrapper>{children}</T3SiteWrapper>;
    }
    case WomanAndHome: {
      return <WomanandhomeSiteWrapper>{children}</WomanandhomeSiteWrapper>;
    }
    case Wallpaper: {
      return <WallpaperSiteWrapper>{children}</WallpaperSiteWrapper>;
    }
    case WhoWhatWear: {
      return <WhowhatwearSiteWrapper>{children}</WhowhatwearSiteWrapper>;
    }
    case TheWeek: {
      return <TheweekSiteWrapper>{children}</TheweekSiteWrapper>;
    }
    case MoneyWeek: {
      return <MoneyweekSiteWrapper>{children}</MoneyweekSiteWrapper>;
    }
    case PracticalCaravan: {
      return <PracticalcaravanSiteWrapper>{children}</PracticalcaravanSiteWrapper>;
    }
    case PracticalMotorhome: {
      return <PracticalmotorhomeSiteWrapper>{children}</PracticalmotorhomeSiteWrapper>;
    }
    case TheBlend: {
      return <TheBlendSiteWrapper>{children}</TheBlendSiteWrapper>;
    }
    case SheerLuxe: {
      return <SheerLuxeSiteWrapper>{children}</SheerLuxeSiteWrapper>;
    }
    default: {
      return <DefaultSiteWrapper>{children}</DefaultSiteWrapper>;
    }
  }
};
